export const REPOSITORIES_API_URL = 'https://api.github.com/graphql';
